import type { MessageKey } from "./ru"

export const nlMessages = {
  "common.loading": "Laden...",
  "common.error": "Fout",
  "common.back": "Terug",
  "common.next": "Volgende",
  "common.search": "Zoeken",
  "auth.loginErrorTitle": "Aanmeldfout",
  "auth.openViaTelegram": "Open de app via Telegram",
  "auth.telegramRequired": "De app moet via Telegram worden geopend",
  "auth.authorizationError": "Autorisatiefout",
  "device.rotatePortrait": "Draai je apparaat naar de staande modus",
  "country.brazil": "Brazilië",
  "country.vietnam": "Vietnam",
  "country.egypt": "Egypte",
  "country.india": "India",
  "country.indonesia": "Indonesië",
  "country.iran": "Iran",
  "country.spain": "Spanje",
  "country.italy": "Italië",
  "country.kazakhstan": "Kazachstan",
  "country.colombia": "Colombia",
  "country.malaysia": "Maleisië",
  "country.mexico": "Mexico",
  "country.nigeria": "Nigeria",
  "country.pakistan": "Pakistan",
  "country.russia": "Rusland",
  "country.usa": "Verenigde Staten",
  "country.turkey": "Turkije",
  "country.uzbekistan": "Oezbekistan",
  "country.ukraine": "Oekraïne",
  "country.philippines": "Filipijnen",
  "countrySelection.chooseCountry": "Kies een land",
  "countrySelection.openAria": "Kies een land",
  "languageSelection.chooseLanguage": "Kies een taal",
  "commercial.direction.autotrade": "Automarkt",
  "commercial.direction.insurance": "Verzekering",
  "commercial.direction.pitstop": "Pit Stop",
  "commercial.direction.techhelp": "Pechhulp",
  "commercial.searchLabel": "BeepApp zoeken",
  "commercial.cityPlaceholder": "Voer een stad in",
  "commercial.emptyTitle": "Vandaag geen aanbiedingen",
  "commercial.emptyLine1": "Er zijn nog geen actieve BeepApp-partners in jouw stad",
  "commercial.emptyLine2": "We werken al aan het vinden en aansluiten van partners",
  "commercial.emptyLine3": "Nieuwe aanbiedingen verschijnen hier automatisch",
  "commercial.helperLine1": "Voer je stad in om",
  "commercial.helperLine2": "beschikbare aanbiedingen te bekijken",
  "commercial.partnerPrompt": "BeepApp-partner worden?",
  "commercial.apply": "Aanmelden",
  "main.admin": "Admin",
  "main.garage": "Garage",
  "main.signalSent": "Signaal verzonden",
  "main.partnerInviteUnavailable": "Partneruitnodiging niet beschikbaar",
  "main.enterPlate": "Voer kenteken in",
  "main.searchError": "Zoekfout",
  "main.signalSendError": "Signaal kon niet worden verzonden",
  "main.shareCardPrefix": "Kentekenkaart",
  "main.shareLinkError": "Link kon niet worden voorbereid",
  "main.searchByPlateAria": "Zoeken op kenteken",
  "main.russianPlateAria": "Russisch kenteken",
  "main.plateAria": "Kenteken",
  "main.findPlateAria": "Kenteken zoeken",
  "main.loadingVehicle": "Voertuigkaart laden…",
  "main.leaveSignal": "Signaal sturen",
  "main.share": "Delen",
  "signalSelection.chooseType": "Kies signaaltype",
  "signalSelection.category.attention": "Persoonlijk",
  "signalSelection.category.road": "Verkeer",
  "signalSelection.category.urgent": "Urgent",
  "signalSelection.chooseSignal": "Kies een signaal",
  "signalSelection.suggestOwn": "Eigen voorstel doen",
  "signalConfirmation.title": "Signaal bevestigen",
  "signalConfirmation.plateHeading": "Controleer het kenteken",
  "signalConfirmation.signalHeading": "Controleer het gekozen signaal",
  "signalConfirmation.replyTitle": "Antwoord in Telegram toestaan",
  "signalConfirmation.replyBody": "Schakel dit in zodat de kentekenhouder je\nin Telegram kan berichten. Antwoorden kan alleen als\nje een @username hebt. De beslissing om te antwoorden\nblijft bij de kentekenhouder.",
  "signalConfirmation.consentText": "Ik bevestig dat dit signaal een\nwerkelijke situatie weergeeft en geen spam\nof valse melding is.",
  "signalConfirmation.warning": "Na verzending kan het signaal\nniet meer worden gewijzigd",
  "signalConfirmation.sending": "Verzenden…",
  "signalConfirmation.send": "Verzenden",
  "partner.loadingAria": "Laden",
  "partner.title": "Partnerprogramma",
  "partner.offerLine1": "Verdien doorlopend 30% op alle betalingen",
  "partner.offerLine2": "van gebruikers die je voor BeepApp uitnodigt",
  "partner.offerLine3": "via het Telegram-affiliateprogramma",
  "partner.connectUnavailable": "Verbinding wordt beschikbaar nadat het Telegram-affiliateprogramma is ingesteld.",
  "partner.connectTelegram": "Verbinden in Telegram",
  "partner.qrAria": "QR-code van partnerlink",
  "partner.download": "Downloaden",
  "partner.promoHeading": "Persoonlijke promotiecode maken",
  "partner.promoHelperLine1": "De promotiecode activeert een extra abonnementsjaar",
  "partner.promoHelperLine2": "en helpt gebruikers aan te trekken",
  "partner.promoAria": "Promotiecode",
  "partner.affiliateHeading": "Jouw affiliatelink",
  "partner.affiliateHelper": "Sla de link op om een persoonlijke QR-code te maken",
  "partner.affiliateAria": "Affiliatelink",
  "partner.qrNoteLine1": "De QR-code kan op je voertuig worden geplaatst,",
  "partner.qrNoteLine2": "op sociale media en in reclamemateriaal",
  "partner.save": "Opslaan",
  "partner.reset": "Resetten",
  "partner.resetConfirm": "Opgeslagen affiliatelink resetten? De promotiecode blijft van jou.",
  "partner.promoFormatError": "De promotiecode moet 4 tot 15 tekens bevatten.",
  "partner.affiliateHostError": "Alleen links van t.me of telegram.me zijn toegestaan.",
  "partner.affiliatePathError": "De link bevat geen Telegram-pad.",
  "partner.affiliateFormatError": "Ongeldige affiliatelink.",
  "partner.loadError": "Laadfout",
  "partner.checkInputError": "Controleer de ingevoerde gegevens",
  "garageActivation.promoInvalid": "Promotiecode is ongeldig",
  "garageActivation.plateOccupied": "Dit kenteken is al gekoppeld",
  "garageActivation.activateError": "Garage kon niet worden geactiveerd",
  "garageEntry.loadJournalError": "Logboek kon niet worden geladen",
  "garageEntry.loadStatusesError": "Statussen konden niet worden geladen",
  "garageEntry.activationSuccess": "Garage succesvol geactiveerd",
  "garageEntry.plateAttached": "Kenteken gekoppeld",
  "garageEntry.attachError": "Kenteken kon niet worden gekoppeld",
  "garageEntry.activationNote": "Activeer je Garage",
  "garageSheet.activationTitle": "Garage activeren",
  "garageSheet.plateHelper": "Voer het kenteken van het voertuig in",
  "garageSheet.promoHelper": "Heb je een promotiecode?",
  "garageSheet.cleanBonusLine1": "Na activering heb je 1 uur",
  "garageSheet.cleanBonusLine2": "voor een gratis ‘Clean Start’",
  "garageSheet.activationFor": "Activering voor",
  "garageSheet.cost": "Kosten",
  "garageSheet.ownerConsentLine1": "Ik bevestig dat ik eigenaar ben",
  "garageSheet.ownerConsentLine2": "van het voertuig met het opgegeven",
  "garageSheet.ownerConsentLine3": "kenteken.",
  "garageSheet.processing": "Verwerken...",
  "garageSheet.attach": "Koppelen",
  "garageSheet.pay": "Betalen",
  "garageLifecycle.cleanTitle": "Clean Start",
  "garageLifecycle.deactivateTitle": "Garage deactiveren",
  "garageLifecycle.cleanWarningLine1": "De kentekengeschiedenis wordt verwijderd",
  "garageLifecycle.cleanWarningLine2": "zonder mogelijkheid tot herstel!",
  "garageLifecycle.deactivateWarningLine1": "Na deactivering eindigt de toegang tot",
  "garageLifecycle.deactivateWarningLine2": "actieve Garage-functies",
  "garageLifecycle.willBeDeleted": "WORDT VERWIJDERD",
  "garageLifecycle.cleanRemovedLine1": "• Alle vermeldingen uit het logboek",
  "garageLifecycle.cleanRemovedLine2": "• Geschiedenis van ontvangen signalen",
  "garageLifecycle.cleanRemovedLine3": "• Openbare signaaltellers",
  "garageLifecycle.cleanRemovedLine4": "  op de kentekenkaart",
  "garageLifecycle.willRemain": "BLIJFT BEHOUDEN",
  "garageLifecycle.cleanPreservedLine1": "• Koppeling van kenteken aan Garage",
  "garageLifecycle.cleanPreservedLine2": "• Resterende activeringsperiode",
  "garageLifecycle.cleanPreservedLine3": "• Gekozen kentekenstatus",
  "garageLifecycle.cleanPreservedLine4": "• Totaal aantal kaartweergaven",
  "garageLifecycle.freeFirstHour": "Gratis tijdens het eerste uur",
  "garageLifecycle.willBecomeUnavailable": "WORDT NIET BESCHIKBAAR",
  "garageLifecycle.deactivateRemovedLine1": "• Logboek",
  "garageLifecycle.deactivateRemovedLine2": "• Kentekenstatus kiezen en gebruiken",
  "garageLifecycle.deactivateRemovedLine3": "• Je verlaat AutoClan automatisch",
  "garageLifecycle.deactivateRemovedLine4": "• Automarkt",
  "garageLifecycle.deactivateRemovedLine5": "• Verzekering",
  "garageLifecycle.deactivateRemovedLine6": "• Pit Stop",
  "garageLifecycle.deactivateRemovedLine7": "• Pechhulp",
  "garageLifecycle.deactivateRemovedLine8": "• Kenteken wordt losgekoppeld van Garage",
  "garageLifecycle.willRemainAvailable": "BLIJFT BESCHIKBAAR",
  "garageLifecycle.deactivatePreservedLine1": "• Metgezel",
  "garageLifecycle.deactivatePreservedLine2": "• Dispatcher",
  "garageLifecycle.deactivatePreservedLine3": "• Kenteken zoeken en bekijken",
  "garageLifecycle.deactivatePreservedLine4": "  de openbare voertuigkaart",
  "garageLifecycle.deactivatePreservedLine5": "• Mogelijkheid om de Garage",
  "garageLifecycle.deactivatePreservedLine6": "  op elk moment opnieuw te activeren",
  "garageLifecycle.cleanConsentLine1": "Ik stem in met het verwijderen",
  "garageLifecycle.cleanConsentLine2": "van de volledige geschiedenis van dit kenteken",
  "garageLifecycle.cleanConsentLine3": "zonder mogelijkheid tot herstel.",
  "garageLifecycle.deactivateConsentLine1": "Ik bevestig de deactivering en",
  "garageLifecycle.deactivateConsentLine2": "het beëindigen van toegang tot alle",
  "garageLifecycle.deactivateConsentLine3": "actieve Garage-functies.",
  "garageLifecycle.clean": "Wissen",
  "garageLifecycle.deactivate": "Deactiveren",
} satisfies Record<MessageKey, string>
